import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import type { ProviderModel } from '@models/types'

interface ContactDetailsProps {
  providerSalesforceDetails: ProviderModel['salesforce_details'],
}

const ContactDetails = (props: ContactDetailsProps) => {
  const { providerSalesforceDetails } = props

  const contactDetailsPayload = [
    { label: 'Email', value: providerSalesforceDetails?.accounts_email },
    { label: 'Phone', value: providerSalesforceDetails?.accounts_phone },
    { label: 'Website', value: providerSalesforceDetails?.website },
  ]

  return (
    <DashboardModule title="Contact">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {contactDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default ContactDetails
